import AssignedPage from './components/AssignedPage';
import './index.scss';

const Assigned = () => {
  return <AssignedPage />;
};

export default Assigned;
